<template>
  <!--  <page-header-wrapper>-->
  <!--    <a-card :bordered="false">-->
  <a-drawer width="90%" :label-col="4" :wrapper-col="14" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!--          <a-col :md="8" :sm="24">-->
          <!--            <a-form-item label="类型id" prop="goodsId">-->
          <!--              <a-input v-model="queryParam.goodsId" placeholder="请输入类型id" allow-clear/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->

          <a-col :md="8" :sm="24">
            <a-form-item label="昵称" prop="nickname">
              <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="手机号" prop="mobile">
              <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="发评论人id, zb_user-id" prop="userId">
                <a-input v-model="queryParam.userId" placeholder="请输入发评论人id, zb_user-id" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="回复他人id, zb_user-id" prop="replyUserId">
                <a-input v-model="queryParam.replyUserId" placeholder="请输入回复他人id, zb_user-id" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="回复评论id, 上级评论id, zb_user_dynamic_comment-id" prop="replyCommentId">
                <a-input v-model="queryParam.replyCommentId" placeholder="请输入回复评论id, 上级评论id, zb_user_dynamic_comment-id" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="一级评论id" prop="topCommentId">
                <a-input v-model="queryParam.topCommentId" placeholder="请输入一级评论id" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="点赞数量" prop="likeCount">
                <a-input v-model="queryParam.likeCount" placeholder="请输入点赞数量" allow-clear/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
              <!--                  {{ advanced ? '收起' : '展开' }}-->
              <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
              <!--                </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作 -->
    <div class="table-operations">
      <!--      <a-button type="primary" @click="$refs.createForm.handleAdd({-->
      <!--          goodsId:goodsId,-->
      <!--          type:type,-->
      <!--          replyCommentId:null-->
      <!--      })">-->
      <!--        <a-icon type="plus" />新增-->
      <!--      </a-button>-->
      <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['skoda:comment:edit']">-->
      <!--          <a-icon type="edit" />修改-->
      <!--        </a-button>-->
      <!--      <a-button type="danger" :disabled="multiple" @click="handleDelete">-->
      <!--        <a-icon type="delete" />删除-->
      <!--      </a-button>-->
      <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['skoda:comment:export']">-->
      <!--          <a-icon type="download" />导出-->
      <!--        </a-button>-->
      <table-setting
        :style="{float: 'right'}"
        :table-size.sync="tableSize"
        v-model="columns"
        :refresh-loading="loading"
        @refresh="getList"
        style="margin-bottom: 20px;" />
    </div>
    <!-- 增加修改 -->
    <create-form
      ref="createForm"
      @ok="getList"
    />
    <!-- 数据展示 -->

    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :scroll="{x:'auto'}"
      :bordered="tableBordered"
    >

      <span slot="sort" slot-scope="text, record" >
        <a-input-number :min="0" :step="1" v-model="record.sort" v-if="!record.topCommentId" @change="changeInput($event,record)" />
        <span v-else>{{ record.sort }}</span>
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <!--          <a-divider type="vertical" />-->
        <!--                  <a @click="$refs.createForm.handleAdd({-->
        <!--          goodsId:goodsId,-->
        <!--          type:type,-->
        <!--          replyCommentId:record.id-->
        <!--      })" >-->
        <!--                    <a-icon type="edit" />回复-->
        <!--                  </a>-->
        <a-divider type="vertical" />
        <a @click="handleDelete(record)" >
          <a-icon type="delete" />删除
        </a>
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-drawer>

<!--    </a-card>-->
<!--  </page-header-wrapper>-->
</template>

<script>
import { pageComment, listComment, delComment, updateComment } from '@/api/user/comment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Comment',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      visible: false,
      // 查询参数
      queryParam: {
        goodsId: null,
        content: null,
        userType: null,
        userId: null,
        replyUserId: null,
        replyCommentId: null,
        topCommentId: null,
        likeCount: null,
        type: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
          width: 200
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          width: 100
        },

        {
          title: '手机号',
          dataIndex: 'mobile',
          align: 'center',
          width: 100
        },
        {
          title: '被回复人昵称',
          dataIndex: 'replyNickname',
          align: 'center',
          width: 200
        },

        {
          title: '被回复人手机号',
          dataIndex: 'replyMobile',
          align: 'center',
          width: 200
        },
        // {
        //   title: '回复他人id, zb_user-id',
        //   dataIndex: 'replyUserId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '回复评论id, 上级评论id, zb_user_dynamic_comment-id',
        //   dataIndex: 'replyCommentId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '一级评论id',
        //   dataIndex: 'topCommentId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '类型id',
        //   dataIndex: 'goodsId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '评论内容',
          dataIndex: 'content',
          width: 300,
          align: 'center'
        },
        // {
        //   title: '类型:0普通 1-作者',
        //   dataIndex: 'userType',
        //   ellipsis: true,
        //   align: 'center'
        // },

        {
          title: '点赞数量',
          dataIndex: 'likeCount',
          width: 100,
          align: 'center'
        },
        // {
        //   title: '排序',
        //   dataIndex: 'sort',
        //   align: 'center',
        //   width: 120,
        //   scopedSlots: { customRender: 'sort' },
        // },
        {
          title: '评论时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 200
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '类型:0-畅聊吧帖子 1-派对场帖子 2-品牌馆分类',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      formTitle: '评论记录',
      goodsId: '',
      type: 0
    }
  },
  filters: {
  },
  created () {
    // this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    changeInput(e, record) {
      const recordData = JSON.parse(JSON.stringify(record))
      this.updateData(recordData)
    },
    updateData(record) {
      updateComment(record).then(res => {
        console.log(res)
        if (res.code == 20001) {
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    show(record, num) {
      if (record) {
        this.goodsId = record.id
        this.queryParam.goodsId = record.id
      } else {
        this.goodsId = null
        this.queryParam.goodsId = null
      }
      this.type = num
      this.queryParam.type = num
      this.getList()
      this.visible = true
    },
    onClose() {
      this.visible = false
      this.$emit('ok')
    },
    /** 查询用户评论列表 */
    getList () {
      this.loading = true
     pageComment(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        goodsId: this.goodsId,
        content: undefined,
        userType: undefined,
        userId: undefined,
        replyUserId: undefined,
        replyCommentId: undefined,
        topCommentId: undefined,
        likeCount: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delComment(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('skoda/comment/export', {
            ...that.queryParam
          }, `用户评论_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
